<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="acknowledgement">
<h1>Acknowledgement</h1>
<p>My grateful thanks for the pathways laid out for me which led to my father, Jack, mother, Mary, my first wife with the Lord, Phyllis, my gracious present wife, Carole, her mother, May, her father, John, my two sons, David and Chris, my daughter-in-law, Inhye, and my grandson Ben.</p><br/>
<p style="text-indent:00em;">I also acknowledge the debt I owe to all the believing people of the Church sent to guide me into God’s Kingdom; my Sunday school teachers, ministers, and pastors.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch004.vue?0449b86c